module.exports = __webpack_public_path__ + "static/wipay-efb72b45d803189afff06df7a32ab8e0.png";